import { axiosPost } from '@/api/AxiosApi';
// 인증번호 문자 발송
export type sendMSmsProps = {
  country: string;
  to: string;
};
export const sendSms = async (aData: sendMSmsProps) => {
  const { country, to } = aData;
  const payload = {
    path: '/v1/dormantSendSms',
    body: {
      country,
      to,
    },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
